import { ArrowLeft, ArrowRight } from "lucide-react";
import { CATS, STOCK, logo, ron } from "@/lib/bf";
import { useEffect, useState } from "react";
import { fetchCatalogs } from "@/lib/bf";
import { CatalogLink, MinPrices, PackCard } from "./BFCampaigns";
import { OfferView } from "./BFOffer";

const SUB = { culoare: "Vopsele și oxidanți", decolorare: "Pudre și oxidanți", ingrijire: "Îngrijire lungimi și scalp" };

export const TopButton = ({ onOpen }) => (
  <button type="button" className="bf-top-btn" onClick={onOpen} data-testid="bf-brands-open">
    <span className="bf-top-shine" />
    <span className="bf-top-txt">Branduri profesionale de top</span>
    <span className="bf-top-cta">Vezi ofertele <ArrowRight size={18} /></span>
  </button>
);

const Back = ({ to, label, go }) => (
  <button type="button" className="bf-back" onClick={() => go(to)} data-testid="bf-back"><ArrowLeft size={15} /> {label}</button>
);

export const BrandsZone = ({ cfg, go }) => (
  <section className="bf-zone" data-testid="bf-brands-zone">
    <Back to="" label="Înapoi" go={go} />
    <h2 className="bf-zone-title">Branduri profesionale de top</h2>
    <p className="bf-zone-sub">Alege brandul ca să vezi campaniile Black Friday.</p>
    <p className="bf-stock bf-stock--center" data-testid="bf-brands-stock">{STOCK}</p>
    <div className="bf-brand-grid">
      {cfg.brands.map((b, i) => {
        const n = cfg.campaigns.filter((c) => c.brand === b.id).length;
        const of = cfg.campaigns.find((c) => c.brand === b.id && c.category === "oferta");
        return (
          <button key={b.id} type="button" className={`bf-brand-tile ${n ? "" : "is-soon"}`} style={{ animationDelay: `${i * 70}ms` }} onClick={() => go(`b/${b.id}`)} data-testid={`bf-brand-tile-${b.id}`}>
            <img src={logo(b.id)} alt={b.name} />
            <small>{of ? `-${of.discount}% · comandă ${ron((of.min_list || 0) + (of.surprise_value || 0))}` : n ? `${n} pachete` : "în curând"}</small>
          </button>
        );
      })}
    </div>
  </section>
);

export const BrandView = ({ cfg, brand, go, cart, setQty }) => {
  const b = cfg.brands.find((x) => x.id === brand);
  const offer = cfg.campaigns.find((c) => c.brand === brand && c.category === "oferta");
  if (offer) return <OfferView key={offer.id} cfg={cfg} c={offer} cart={cart} setQty={setQty} back={<Back to="branduri" label="Toate brandurile" go={go} />} />;
  const cats = CATS.filter(([k]) => cfg.campaigns.some((c) => c.brand === brand && c.category === k));
  return (
    <section className="bf-zone" data-testid={`bf-brand-view-${brand}`}>
      <Back to="branduri" label="Toate brandurile" go={go} />
      <img className="bf-zone-logo" src={logo(brand)} alt={b?.name} />
      {!cats.length ? <p className="bf-zone-sub" data-testid="bf-no-campaigns">Campaniile {b?.name} vor fi anunțate în curând.</p> : (
        <div className="bf-cat-grid">
          {cats.map(([k, label], i) => {
            const list = cfg.campaigns.filter((c) => c.brand === brand && c.category === k);
            return (
              <button key={k} type="button" className="bf-cat-tile" style={{ animationDelay: `${i * 100}ms` }} onClick={() => go(`b/${brand}/${k}`)} data-testid={`bf-cat-${k}`}>
                <span className="bf-cat-name">{label}</span>
                <small>{SUB[k] || ""}</small>
                <em>{list.length} pachete · până la -{Math.max(...list.map((c) => c.discount))}%</em>
                <ArrowRight size={20} className="bf-cat-arrow" />
              </button>
            );
          })}
        </div>
      )}
    </section>
  );
};

export const CategoryView = ({ cfg, brand, cat, go, cart, setQty, contact, onWant }) => {
  const byId = Object.fromEntries(cfg.products.map((p) => [p.id, p]));
  const camps = cfg.campaigns.filter((c) => c.brand === brand && c.category === cat);
  const label = CATS.find(([k]) => k === cat)?.[1] || "";
  const [catalogs, setCatalogs] = useState([]);
  useEffect(() => { fetchCatalogs().then(setCatalogs).catch(() => {}); }, []);
  const mine = catalogs.filter((x) => x.brand === brand);
  return (
    <section className="bf-zone bf-zone--cat" data-testid={`bf-cat-view-${cat}`}>
      <Back to={`b/${brand}`} label={cfg.brands.find((x) => x.id === brand)?.name || "Înapoi"} go={go} />
      <div className="bf-cat-head"><h2 data-testid="bf-cat-title">{label}</h2></div>
      <MinPrices camps={camps} byId={byId} cat={cat} />
      {cat === "culoare" && mine.length > 0 && (
        <div className="bf-catalogs" data-testid="bf-catalogs">
          <h3 className="bf-group-title">Cataloage de nuanțe</h3>
          <div>{mine.map((x) => <CatalogLink key={x.id} cat={x} />)}</div>
        </div>
      )}
      <h3 className="bf-group-title">Pachete</h3>
      {cat === "culoare" && camps.some((c) => c.items.some((id) => byId[id] && !byId[id].shades?.length)) && <p className="bf-camp-hint">Nuanțele le scrii în mesajul WhatsApp sau le stabilești cu agentul.</p>}
      <div className="bf-camp-grid">
        {camps.map((c, i) => <PackCard key={c.id} c={c} i={i} byId={byId} cart={cart} setQty={setQty} contact={contact} onWant={onWant} catalogs={catalogs} brandName={cfg.brands.find((x) => x.id === brand)?.name || ""} />)}
      </div>
    </section>
  );
};
